import { PictureProps } from '../props/shape/picture-props';
import { PictureStore } from '../store/picture-store';
import { PictureMutationAPI } from '../api/picture-mutation-api';
import { BaseShapeDataModel } from './base-shape-data-model';
import type { PageContext } from '../context/page-context';
import type { IEventManager } from '../manager/event-manager';
import type { IPictureData } from '../data';
import type { IPictureProps } from '../props/shape/picture-props';
import type { RestrictedDataModel } from './data-model';
import type { GroupShapeDataModel } from './group-shape-data-model';

export class PictureDataModel extends BaseShapeDataModel<IPictureData> {
    public store: PictureStore;
    public props: IPictureProps;
    public api: PictureMutationAPI;

    public constructor(
        data: IPictureData,
        events: IEventManager,
        context: PageContext,
        public parent: GroupShapeDataModel,
    ) {
        super(events, context);

        this.store = new PictureStore(data, events, this);
        this.props = new PictureProps(this.store.data, this.context);
        this.api = new PictureMutationAPI(this, events);
    }

    /**
     * 获取此 picture 在母版版式上相关联的 shapeModel（占位符）
     */
    public getRelatedPlaceholder() {
        return this.context.getPlaceholder(this.props.nvPr?.ph);
    }
}

export { IPictureProps };
export type IPictureDataModel = RestrictedDataModel<PictureDataModel>;
